import React from "react";

export default function OpacityBlack() {
    return (
        <div className="custom-body unclickable">
        
        </div>
    )
}
